//import config from 'emun.retailer/retailer.config'
import templateUrl from 'emun.shopping.admin/abandoned-carts-list.html'
class AbandonedCartsListController  {
    constructor(createAutoQuery, $session) {
        this.vendor = {
            id: null
        }
        this.dateRange = {
            id: "Custom",
            name: "Custom"
        };
        this.customRange = {
            startDate: new Date(),
            endDate: new Date()
        };
        let options = {
//            url: 'QueryOrders.json?StatusEqualTo=Cart',
            url: 'QueryAbandonedCarts.json',
            //fields: 'Id,Prefix,Status,OrderDate,OrderTotal,Tracking,RetailerEmail',
            pageSize: 24,
            orderBy:'-OrderedOn',
            append:true,
            autoLoad:true,
            sortOptions:{
                'Id': 'Id: Low to High',
                '-Id': 'Id: High to Low',
                'Prefix': 'Cart Name: A to Z',
                '-Prefix': 'Cart Name: Z to A',
                'Status': 'Status: A to Z',
                '-Status': 'Status: Z to A',
                'OrderDate': 'Date: Newest',
                '-OrderDate': 'Date: Oldest',
                'OrderTotal': 'Amount: Low to High',
                '-OrderTotal': 'Amount: High to Low',
            },
            criteria: {
                vendorId: this.vendor.id,
                dateRange: this.dateRange.id,
                startDate: this.customRange.startDate,
                endDate: this.customRange.endDate
            }
        };
        this.query = createAutoQuery(options);
        this.vendors = createAutoQuery({
            url: 'QueryVendors.json',
            orderBy: 'VendorName',
            autoLoad: true,
            pageSize: 100,
            onLoaded: args => { if (args.results.count > 1) {this.vendor.id = this.$session.vendorId}}
        });
        this.$session = $session;
        //console.warn('emun.retailer/retailer.config', config);
    }
    load(){return this.query.load.apply(this.query, arguments);}
    //selectVendor(){
    //    this.query.criteria.vendorId = this.vendor.id; 
    //    this.query.load(true);
    //}
    reload() {
        this.query.criteria.vendorId = this.vendor.id; 
        this.query.criteria.dateRange = this.dateRange.id;
        this.query.criteria.startDate = this.customRange.startDate;
        this.query.criteria.endDate = this.customRange.endDate;
        this.query.load(true);
    }

    downloadData() {
        let $ctrl = this;
        var url = "/service/QueryAbandonedCarts.csv?dateRange=" + $ctrl.dateRange.id + "&startDate=" + $ctrl.customRange.startDate.toLocaleDateString("en-US") + "&endDate=" + $ctrl.customRange.endDate.toLocaleDateString("en-US") + "&Fields=PurchaserEmail,VendorId,VendorName,GeneratedFrom,OrderedOn,GrandTotal,Id";
        console.info("BL*** url = " + url);
        return location.href = url;
    }
}

class AbandonedCartsList{
    constructor(){
        this.controller = AbandonedCartsListController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'abandoned-carts-list.html'
    }
}

export default  AbandonedCartsList;

angular.module('emun.shopping.admin').component('abandonedCartsList', new AbandonedCartsList());